import React from "react";

const LoadingComponent = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-white/60 backdrop-blur-sm flex flex-col items-center justify-center z-50">
      <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-slow-spin mb-4"></div>

      <p className="text-lg font-semibold text-gray-700">{message}</p>
    </div>
  );
};

export default LoadingComponent;
